<app-welcome-dialog></app-welcome-dialog>
<app-toast></app-toast>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="0" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.dashboard' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block"></app-mobile-topbar>
            <div class="flex gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.overview' | transloco }}" [isActive]="true"
                    link="/dashboard/overview"></app-tab-button>
                <app-tab-button label="{{ 'shared.electricity' | transloco }}"
                    link="/dashboard/electricity"></app-tab-button>
                <app-tab-button label="{{ 'shared.gas' | transloco }}" link="/dashboard/gas"></app-tab-button>
            </div>

            <!-- No membership popup -->
            <div class="mt-4">
                <app-no-membership-popup [visible]="!hasPlusSubscription"></app-no-membership-popup>
            </div>

            <!-- Extraction ongoing popup -->
            <div class="mt-4">
                <app-extraction-ongoing-popup [visible]="isExtractionOngoing"></app-extraction-ongoing-popup>
            </div>

            <!--Total Energy Consumption and Cost-->
            <div
                class="mt-4 w-full max-w-ultrawide flex-col rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm h-auto">
                <div class="flex mt-4 justify-between">
                    <div class="flex flex-col gap-4 h-[70px] justify-between">
                        <div class="flex flex-col flex-grow justify-center text-center">
                            <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{
                                'dashboard.total_energy_consumption_and_cost' | transloco }}</p>
                        </div>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="h-[70px]  flex flex-grow items-end justify-start">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                    <div class="h-[70px] flex flex-col justify-between">

                        <div class="flex gap-2 mr-4 items-center">
                            <!-- 
                        Budgeting Out of Scope
                        <p class="font-bold">Show budget</p>
                        <app-toggle-button></app-toggle-button>
                        -->
                            <div
                                class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                <p-calendar class="w-[50px]" [(ngModel)]="totalEnergyConsumptionAndCostDate" view="year"
                                    readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                    (onClose)="totalEnergyConsumptionAndCostYearChange()" [minDate]="datePickerMinYear"
                                    [maxDate]="totalEnergyConsumptionAndCostMaxYearDate" />
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                            </div>
                        </div>
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>

                <div class="flex flex-col items-center">
                    <div class="flex gap-0 w-[95%] h-auto">
                        <div class="relative h-auto w-[95%] flex-grow p-4 mobile:p-2">
                            <div class="h-[200px] largeScreen:h-[300px] mobile:h-[100px] w-[95%]">
                                <app-budget-total-costs-chart [showDummyData]="showDummyData" [totalCosts]="totalCosts"
                                    [forecastedStartMonth]="totalCostsForecastedStartMonth"></app-budget-total-costs-chart>
                            </div>
                            <div class="h-[300px] largeScreen:h-[500px] mobile:h-[250px] w-[95%]">
                                <app-energy-chart [showDummyData]="showDummyData" [gasActualData]="gasActualData"
                                    [gasForecastData]="gasForecastData" [electricityActualData]="electricityActualData"
                                    [electricityForecastData]="electricityForecastData"
                                    [gasActualConsumption]="gasActualConsumption"
                                    [gasForecastConsumption]="gasForecastConsumption"
                                    [electricityActualConsumption]="electricityActualConsumption"
                                    [electricityForecastConsumption]="electricityForecastConsumption"></app-energy-chart>
                            </div>
                            <app-complete-energy-profile [showPopup]="noDataDialogShow"></app-complete-energy-profile>
                        </div>
                        <app-flex-upgrade [showUpgrade]="showUpgrade" [showTextUnder]="true"></app-flex-upgrade>
                    </div>
                </div>

            </div>

            <!--Electricity / Gas (Forecast end of year)-->
            <div class="flex flex-wrap w-full gap-2 justify-between max-w-ultrawide mobile:flex-col">
                <div class="mt-4 relative h-auto flex-[1]">
                    <app-electricity-forecast-eoy [showDummyData]="showDummyData"
                        [consumptionValue]="consumptionValueElectricity" [costValue]="costValueElectricity"
                        [showUpgrade]="showUpgradeGeneral"></app-electricity-forecast-eoy>
                </div>

                <div class="mt-4 relative h-auto flex-[1]">
                    <app-gas-forecast-eoy [showDummyData]="showDummyData" [consumptionValue]="consumptionValueGas"
                        [costValue]="costValueGas" [showUpgrade]="showUpgradeGeneral"></app-gas-forecast-eoy>
                </div>
            </div>

            <div class="flex flex-wrap gap-2 justify-between mobile:flex-col max-w-ultrawide">
                <!--Overview of locations-->
                <div
                    class="mt-4 flex-[1] min-w-[400px] mobile:min-w-[300px] flex-col rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm h-auto">

                    <div class="flex mt-4 justify-between mobile:flex-col">
                        <div class="flex flex-col gap-4 min-h-[60px] justify-between">
                            <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                                'dashboard.overview_of_locations' | transloco }}
                            </p>
                            <div class="h-[2px] w-full bg-primary"></div>
                        </div>
                        <div class="min-h-[60px] w-[100px] flex flex-grow items-end justify-start mobile:hidden">
                            <div class="h-[2px] w-full bg-border"></div>
                        </div>
                        <div
                            class="min-h-[60px] flex flex-col justify-between mobile:justify-center mobile:items-center gap-2 mobile:my-2">

                            <div class="flex desktop:flex-wrap gap-2 mr-4 items-center">
                                <div class="min-w-[150px] desktop:flex-[1]">
                                    <app-custom-dropdown [options]="locationsOverviewEnergyDropdownOptions"
                                        [(selectedOption)]="selectedLocationsOverviewEnergyDropdown"
                                        (selectedOptionChange)="locationsOverviewEnergyFilter()"></app-custom-dropdown>
                                </div>
                                <div class="min-w-[150px] desktop:flex-[1]">
                                    <app-custom-dropdown [options]="locationsOverviewYtdDropdownOptions"
                                        [(selectedOption)]="selectedLocationsOverviewYtdDropdown"
                                        [upgradeIncludes]="locationsOverviewYtdDropdownUpgrade"
                                        (selectedOptionChange)="loadOverviewOfLocationsData($event)"></app-custom-dropdown>
                                </div>

                            </div>
                            <div class="h-[2px] w-full bg-border mobile:hidden"></div>

                        </div>


                    </div>


                    <div class="relative h-auto w-[95%] p-4 mobile:p-2">
                        <div class="h-[300px] largeScreen:h-[500px] w-[95%] max-w-[1000px] justify-self-center">
                            <app-locations-overview-chart [showDummyData]="showDummyData" [labels]="olLabels"
                                [electricityData]="olElectricityData"
                                [gasData]="olGasData"></app-locations-overview-chart>
                        </div>
                        <app-complete-energy-profile
                            [showPopup]="noDataDialogShowOverview"></app-complete-energy-profile>
                    </div>

                </div>

                <!--Yearly view per locations-->
                <div
                    class="mt-4 flex-[1] min-w-[400px] mobile:min-w-[300px] flex-col rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm h-auto">

                    <div class="flex mt-4 justify-between mobile:flex-col">
                        <div class="flex flex-col gap-4 min-h-[60px] justify-between mobile:flex-col">
                            <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                                'dashboard.yearly_view_per_locations' | transloco }}</p>
                            <div class="h-[2px] w-full bg-primary"></div>
                        </div>
                        <div class="min-h-[60px] w-[100px] flex flex-grow items-end justify-start mobile:hidden">
                            <div class="h-[2px] w-full bg-border"></div>
                        </div>
                        <div
                            class="min-h-[60px] flex flex-col gap-2 justify-between mobile:justify-center mobile:items-center mobile:my-2">

                            <div class="flex desktop:flex-wrap gap-2 mr-4 items-center mobile:flex-col">
                                <div class="min-w-[150px] desktop:flex-[1] mobile:w-[300px]">
                                    <app-custom-dropdown [options]="locationsDropdownOptions"
                                        [(selectedOption)]="selectedLocationDropdown"
                                        (selectedOptionChange)="loadYearlyViewPerLocationsData($event)"></app-custom-dropdown>
                                </div>
                                <div class="min-w-[150px] desktop:flex-[1]">
                                    <app-custom-dropdown [options]="yearlyViewEnergyDropdownOptions"
                                        [(selectedOption)]="selectedYearlyViewEnergyDropdown"
                                        (selectedOptionChange)="locationsYearlyViewPerLocationEnergyFilter()"></app-custom-dropdown>
                                </div>
                                <div class="min-w-[150px] desktop:flex-[1]">
                                    <app-custom-dropdown [options]="yearlyViewYtdDropdownOptions"
                                        [(selectedOption)]="selectedYearlyViewYtdDropdown"
                                        [upgradeIncludes]="yearlyViewYtdDropdownUpgrade"
                                        (selectedOptionChange)="loadYearlyViewPerLocationsData($event, true)"></app-custom-dropdown>
                                </div>

                            </div>
                            <div class="h-[2px] w-full bg-border mobile:hidden"></div>
                        </div>
                    </div>
                    <div
                        class="h-[300px] largeScreen:h-[500px] mobile:h-[350px] w-[95%] justify-self-center p-4 mobile:p-2">
                        <app-yearly-view-per-location-chart [showDummyData]="showDummyData"
                            [electricityActualData]="yvpl_electricityActualData"
                            [electricityForecastData]="yvpl_electricityForecastData"
                            [gasActualData]="yvpl_gasActualData" [gasForecastData]="yvpl_gasForecastData"
                            [totalCostsData]="yvpl_totalCostsData" [chartDisplayYear]="yearlyViewPerLocationsDataYear"
                            [fromDate]="fromDate" [showElectricityForecastDataset]="yvpl_showElectricityForecastDataset"
                            [showGasForecastDataset]="yvpl_showGasForecastDataset"></app-yearly-view-per-location-chart>
                    </div>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>